"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BarDeCoctelesYMezcal() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const {
    ref: image1Ref,
    isVisible: image1Visible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: image2Ref,
    isVisible: image2Visible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section id="bar-de-cócteles-y-mezcal" className="dark bg-background text-foreground relative min-h-screen overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/mezcal_bar_ambient_lighting.png)] bg-cover bg-center h-full w-full" />
        <div className="absolute inset-0 bg-black/40" />
      </div>

      {}
      <div ref={sectionRef} className={`relative z-10 container mx-auto px-4 py-24 md:py-32 transition-all duration-[var(--duration-slow)] ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {}
          <div className="space-y-6">
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-accent leading-tight">
              Arte en Cada Copa
            </h2>
            <p className="text-foreground-dark text-lg md:text-xl leading-relaxed max-w-xl">
              Descubre nuestra selección exclusiva de mezcales artesanales y
              cócteles creativos, elaborados con pasión por nuestros expertos
              mixólogos en un ambiente íntimo y sofisticado.
            </p>
          </div>

          {}
          <div className="relative h-[400px] md:h-[500px]">
            {}
            <div ref={image1Ref} className={`absolute top-0 left-0 w-[250px] md:w-[300px] rounded-lg overflow-hidden shadow-strong transition-all duration-[var(--duration-slow)] ${image1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: "200ms"
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/crafted_mezcal_cocktail_glass.png" alt="Cocktail artesanal" className="w-full h-full object-cover" />
            </div>

            {}
            <div ref={image2Ref} className={`absolute bottom-0 right-0 w-[280px] md:w-[350px] rounded-lg overflow-hidden shadow-strong transition-all duration-[var(--duration-slow)] ${image2Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: "400ms"
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/signature_mezcal_cocktail_golden.png" alt="Mezcal signature" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}